module.exports = __webpack_public_path__ + "static/img/3.4be7a85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/3.jpg
// module id = 6nzA
// module chunks = 1